import Footer from "../components/footer";
import Header from "../components/Header";
import RightArrrow from "../modules/icons/rightarrow";
import "../style/aboutus.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaCaretRight } from "react-icons/fa";
import { FaRegSmileBeam } from "react-icons/fa";
import { FaSeedling } from "react-icons/fa";
import { FaRocket } from "react-icons/fa";
import { FaHandsHelping } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaBullseye } from "react-icons/fa";

const AboutUs = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="aboutus-container" style={{ backgroundColor: "#B1B3B6" }}>
      <Header />
      <section className="about-alpha">
        <div className="about-alpha-layout">
          <div className="about-alpha-logo-container">
            <div className="about-alpha-left-img">
              <img src="/images/banner/Logo.png" alt="" />
            </div>
          </div>
          <div className="about-alpha-text-container">
            <div className="about-alpha-text">
              <h2
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                About Alpha Electronics{" "}
                <div
                  className="line-div"
                  style={{ border: "1px solid black" }}
                ></div>
              </h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "start",
                  gap: "8px",
                }}
              >
                <div style={{ marginTop: "3px" }}>
                  <FaCaretRight />
                </div>
                Alpha Electronics is a leading local brand, making everyone's
                home more smarter and modern by providing the consumer
                electronics with unique design and high quality in an affordable
                way.
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  className="about-us-description-headeing-layout"
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "row",
                  //   alignItems: "start",
                  //   gap: "8px",
                  // }}
                >
                  <div className="adjust-margin">
                    <FaCaretRight />
                  </div>{" "}
                  Our brands stands on these three important pillars
                </div>

                <div
                  className="about-us-description-list-layout"
                  style={{ listStyle: "none", marginLeft: "1.5rem" }}
                >
                  <span style={{ color: "black", width: "1rem" }}>1.</span>
                  <div>Modern and unique designs</div>
                </div>
                <div
                  className="about-us-description-list-layout"
                  style={{ listStyle: "none", marginLeft: "1.5rem" }}
                >
                  <span style={{ color: "black", width: "1rem" }}>2.</span>{" "}
                  <div>
                    Differentiation from other brands, whether in terms of
                    technology and innovation or the design.
                  </div>
                </div>
                <div
                  className="about-us-description-list-layout"
                  style={{ listStyle: "none", marginLeft: "1.5rem" }}
                >
                  <span style={{ color: "black", width: "1rem" }}>3.</span>{" "}
                  <div>
                    Value for money, to suit the needs of the people of Myanmar.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mvp-container">
        <section className="mvp">
          <div className="mvp-description">
            <div className="mvp-heading">
            <h2>Why you should be our partner?</h2>
            </div>
            <div className="mvp-text">
              <p>
              Being a reputable electronic company in Myanmar, we
                    understand the needs of local consumers well and have been
                    satisfying those with high quality electronics products at
                    affordable prices to keep abreast of latest innovations and
                    technology of the world. We value and preserve a sense of
                    "Excellent After - Sales Service" by understanding customers’
                    concerns to provide prompt and effective solutions.
              </p>
              {/* <p className="bottom-paragraph">
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters
              </p> */}
            </div>
            {/* <div className="mvp-button">
              <a href="/">
                <p>Read More</p><RightArrrow width={24} height={24}/>
              </a>
            </div> */}
          </div>
          <div className="mvp-image-container">
            <div className="mvp-image">
              <img src="images/mvp.jpg" alt="mvp1" />
            </div>
            {/* <div className="mvp-image">
              <img src="/mvp2.jpg" alt="mvp2" />
            </div>
            <div className="mvp-image">
              <img src="/mvp3.jpg" alt="mvp3" />
            </div> */}
          </div>
        </section>
      </section>
      <section className="vision-container">
        <div className="vision-container-layout">
          <div className="vision-container-layout-left">
          <div className="aim-container">
            <div className="sub-aim-container">
              <div className="aim">
                <div className="aim-layout">
                  <h4 style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'1rem'}}>Our Vision <FaEye size={30}/></h4>
                  <p>
                    To become a “pride of Myanmar” electronic brand to penetrate
                    in the international market.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="aim-container">
            <div className="sub-aim-container">
              <div className="aim">
                <div className="aim-layout">
                  <h4 style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'1rem'}}>Our Mission <FaBullseye size={30}/></h4>
                  <p>
                    To become a leading electronics brand to fulfill every
                    residential or commercial needs at an affordable price,
                    while possessing innovative technology and capacity.
                  </p>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="vision-container-layout-right">
            <h2>Our Core Values</h2>
            <div className="core-value-list-container">
              <div className="core-value-list">
                <div><FaRegSmileBeam color="black" size={30}/></div>
                <div className="core-value" style={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                  <div className="eng-p">Positive energy and mindset</div>
                  <div className="mm-p">အကောင်းမြင်စိတ်ဓာတ်ရှိခြင်း</div>
                </div>
              </div>
              <div className="core-value-list">
                <div><FaSeedling color="black" size={30}/></div>
                <div className="core-value" style={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                  <div className="eng-p">Self-growth and Self-improvement</div>
                  <div className="mm-p">မိမိကိုယ်ကိုတိုးတက်ဖို့ကြိုးစားသင်ယူလိုစိတ်ရှိခြင်း</div>
                </div>
              </div>
              <div className="core-value-list">
                <div><FaRocket color="black" size={30}/></div>
                <div className="core-value" style={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                  <div className="eng-p">Do more than expected</div>
                  <div className="mm-p">ရည်မှန်းချက်ထားခြင်းထက်ပို၍လုပ်ဆောင်လိုစိတ်ရှိခြင်း</div>
                </div>
              </div>
              <div className="core-value-list">
                <div><FaHandsHelping color="black" size={30}/></div>
                <div className="core-value" style={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                  <div className="eng-p">Customers are always our first priority.</div>
                  <div className="mm-p">ဝယ်ယူသူတွေကိုသာအဓိကဦးစားပေးခြင်း</div>
                </div>
              </div>
              <div className="core-value-list">
                <div><FaUsers color="black" size={30}/></div>
                <div className="core-value" style={{display:'flex', flexDirection:'column', alignItems:'left'}}>
                  <div className="eng-p">Family spirit</div>
                  <div className="mm-p">မိသားစုစိတ်ဓာတ်ရှိခြင်း</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="blank-separator"></div>
      <Footer />
    </div>
  );
};

export default AboutUs;
